import { Category } from "@mui/icons-material";
import { useState } from "react";
import { useFilterContext } from '../components/FilterContext';
import { useResetContext} from '../components/ResetContext';
const useSegmentedChartQuery = () => {
  const [chartData, setChartData] = useState(null);
  const { filterdata } = useFilterContext();
  const { resetdata } = useResetContext();

  const fetchSegmentedChart = async ({ vinShort, chartType, columnname, category = "null"}) => {
    try {
      let baseURL;

      if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
        baseURL = "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
      } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
      } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
      } else {
        baseURL = "http://localhost:8080";
      }

      const token = localStorage.getItem("idToken");
      if (!token) {
        console.error("No ID token found!");
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(`${baseURL}/get-chart-data`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ vin_short: vinShort, chart_type: chartType, columnname, category ,filterdata, resetdata}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setChartData(result);
      return result;
    } catch (error) {
      console.error("Error fetching segmented chart data:", error);
    }
  };

  return { chartData, fetchSegmentedChart };
};

export default useSegmentedChartQuery;
